export default __webpack_public_path__ + "static/media/hht1_ep11_minisitcom_04.2779e178.png";